import { ReactNode } from 'react'

import { BrowserRouter, Switch, Route } from 'react-router-dom'

import routes from 'core/routes/.'
import Providers from 'core/config/providers'

interface Props {
  children: ReactNode
}

const Router = ({ children }: Props) => {
  return (
    <BrowserRouter>
      <Providers>
        <Switch>
          {
            routes.publicRoutes.map(({ path, page: Comp }, index) => (
              <Route path={path} exact key={index}>
                <Comp />
              </Route>
            ))
          }
        </Switch>
        {children}
      </Providers>
    </BrowserRouter>
  )
}

export default Router
